import { render, staticRenderFns } from "./JSelectCateModal.vue?vue&type=template&id=e1684570&scoped=true"
import script from "./JSelectCateModal.vue?vue&type=script&lang=js"
export * from "./JSelectCateModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectCateModal.vue?vue&type=style&index=0&id=e1684570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1684570",
  null
  
)

export default component.exports